import { createApi } from "@reduxjs/toolkit/query/react";

import type {
  ForecastResultPoint,
  ForecastSummary,
} from "../../../../common/types/Forecast";
import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

// Forecast reads go through nav's BFF (/api/forecasts/*), which owns the SQL and row→DTO
// mapping. The client just consumes typed DTOs.
export const forecastsService = createApi({
  reducerPath: "forecastsService",
  baseQuery: createServiceBaseQuery("bffApiUri"),
  tagTypes: ["Forecast"],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getForecastSummary: builder.query<
      ForecastSummary[],
      { startDate: string; endDate: string }
    >({
      query: ({ startDate, endDate }) => ({
        url: "/api/forecasts/summary",
        params: { startDate, endDate },
      }),
      providesTags: (_result, _err, { startDate, endDate }) => [
        { type: "Forecast", id: `SUMMARY-${startDate}-${endDate}` },
      ],
    }),

    getForecastResults: builder.query<
      ForecastResultPoint[],
      { forecastId: string; location: string | null }
    >({
      query: ({ forecastId, location }) => ({
        url: "/api/forecasts/results",
        // Omit location when null so the BFF treats it as IS NULL (forecasts not tied to a venue).
        params: location === null ? { forecastId } : { forecastId, location },
      }),
      providesTags: (_result, _err, { forecastId, location }) => [
        { type: "Forecast", id: `RESULTS-${forecastId}-${location ?? "null"}` },
      ],
    }),
  }),
});

export const { useGetForecastSummaryQuery, useGetForecastResultsQuery } =
  forecastsService;
